import {observable, action, runInAction} from 'mobx'
import {PAGE_SIZE_DEFAULT} from '../constants/appConstant'
import permissionManagementAPI from '../apis/permissionManagementAPI'
import alertMessage from '../utils/alertMessage'

export default class PermissionManagementAPI {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable pageSize = PAGE_SIZE_DEFAULT
  @observable pageNo = 1
  @observable currIndex = 0
  @observable itemCount = 0

  /*change permissionType*/
  @observable permissionType = 'MENU'

  @action
  onChangePermissionType(value) {
    this.permissionType = value
  }

  /*SearchResult start*/
  @observable searchItem = {
    name: '',
    key: '',
  }
  @observable permissionList = []

  @action
  async onSearchAction(params, pageNo, pageSize) {
    this.isFetching = true
    this.pageNo = pageNo
    this.pageSize = pageSize
    this.itemCount = 0
    try {
      this.searchItem = params
      this.permissionList = []
      const response = await permissionManagementAPI.searchAction(params, pageNo, pageSize, this.permissionType)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.permissionList = response.data.data?.content || []
          this.permissionList.forEach(item => {
            item.children = null
          })
          this.itemCount = response.data.data?.totalElements
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*SearchResult end*/
  @action
  onChangePermissionList(value) {
    this.permissionList = value
  }

  /*add permission*/
  @action
  async onAddPermissionAction(params) {
    this.isFetching = true
    try {
      const response = await permissionManagementAPI.addAction(params, this.permissionType)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Add Success！')
          this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Add Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*get edit permission*/
  @observable detailsObj = null

  @action
  async onGetAction(id) {
    this.isFetching = true
    try {
      const response = await permissionManagementAPI.getAction(id, this.permissionType)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          this.detailsObj = response.data.data || null
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*edit permission*/
  @action
  async onEditPermissionAction(params, id) {
    this.isFetching = true
    try {
      const response = await permissionManagementAPI.editAction(params, id, this.permissionType)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Edit Success！')
          this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Edit Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  /*delete permission*/
  @action
  async onDeletePermissionAction(id) {
    this.isFetching = true
    try {
      const response = await permissionManagementAPI.deleteAction(id, this.permissionType)
      runInAction(() => {
        this.isFetching = false
        if (response.data.code === 0) {
          alertMessage.success('Delete Success！')
          this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
        } else {
          alertMessage.error('Delete Failed！' + response.data.messageEn + '')
        }
      })
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  onChangePageNumAction(pageNo, pageSize) {
    if (this.pageNo === pageNo && (!pageSize || this.pageSize === pageSize)) {
      return
    }
    runInAction(() => {
      this.pageNo = pageNo
      this.pageSize = pageSize
    })
    this.onSearchAction(this.searchItem, this.pageNo, this.pageSize)
  }

  @action
  onChangePageNo() {
    this.pageNo = 1
  }
}
